<template>

  <Modal v-if="visible" :value="true" @input="closeModal">
    <span slot="header">{{ title }}</span>

    <div class="row text-align-center">
      <div class="col-md-12">
        <p>Deseja realmente excluir a empresa {{ company.name }} ({{ company.cnpj | cnpj }})?</p>
        <button class="btn btn-outline btn-md mr-2" @click="closeModal">Agora não</button>
        <button class="btn btn-outline-red btn-md" @click="$emit('sendDeleteModel', company)">Excluir</button>
      </div>
    </div>
  </Modal>

</template>

<script>
  import Modal from '../shares/specialTag/Modal'

  export default {
    components: { Modal },
    computed: {
      visible() {
        return this.company && this.value
      }
    },
    methods: {
      closeModal() { this.$emit('input', false) }
    },
    name: 'ModalDeleteCompany',
    props: {
      company: { type: Object },
      title: { default: 'Excluir empresa', type: String },
      value: { default: false, type: Boolean }
    }
  }
</script>

<style scoped>

</style>
